"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSEPHSBillingComponent = void 0;
const expresspay_services_1 = require("../../shared/services/expresspay.services");
const shared_1 = require("../../../mma/shared");
class CSEPHSBillingComponent {
    constructor(expressPayService, genericContentServiceV2) {
        this.expressPayService = expressPayService;
        this.genericContentServiceV2 = genericContentServiceV2;
        this.classes = 'col-12';
    }
    ngOnInit() {
        this.expressPayService.emitSignedInStatusChange('true');
        this.showPaymentAmountSection();
        this.getGenericContent();
    }
    showPaymentAmountSection() {
        this.addAmountSection = true;
        this.paymentInfoSection = false;
        this.reviewSection = false;
        this.confirmationSection = false;
    }
    showGiftCardDetails($event) {
        this.giftCard = $event;
    }
    showBankDetails($event) {
        this.bankDetails = $event;
    }
    storeBillingAddress($event) {
        this.address = $event;
    }
    storeFiberInfo($event) {
        this.fiberInfo = $event;
    }
    storePaymentDetails($event) {
        this.payment = $event;
    }
    selectedPaymentMethod($event) {
        this.paymentMethod = $event;
    }
    showPaymentInfoSec() {
        this.paymentInfoSection = true;
        this.addAmountSection = false;
        this.reviewSection = false;
        this.confirmationSection = false;
    }
    showReviewSection() {
        this.addAmountSection = false;
        this.paymentInfoSection = false;
        this.reviewSection = true;
        this.confirmationSection = false;
    }
    showPaymentConfirmation() {
        this.addAmountSection = false;
        this.paymentInfoSection = false;
        this.reviewSection = false;
        this.confirmationSection = true;
    }
    editPaymentInfo() {
        this.showPaymentInfoSec();
        this.paymentTypeSelection = this.paymentMethod.setPaymentMethod;
        this.cardSelected = this.paymentMethod.setCCardMethod;
        this.addressSavedCard = this.paymentMethod.setAddressSavedCard;
        this.selectedCount = this.paymentMethod.setCount;
        this.selectedAddress = this.paymentMethod.setAddress;
        this.seltectedPayment = true;
        this.selectedCardDetail = this.payment;
    }
    addAmount($event) {
        this.addedFunds = $event;
    }
    isBankInfoSave($event) {
        this.saveBankData = $event;
    }
    confirmation($event) {
        this.authCode = $event;
    }
    storePaymentType($event) {
        this.paymentmode = $event;
    }
    storeCCDetails($event) {
        this.ccContent = $event;
    }
    addAccNo($event) {
        this.accNo = $event;
    }
    setGenericError($event) {
        this.genericErrorCode904 = $event;
    }
    getConvenienceFeeAmnt($event) {
        this.convenienceFee = $event;
    }
    getGenericContent() {
        const genericContentIds = [
            'genericConvenienceFeeNote'
        ];
        this.genericContentServiceV2.getBulkGenericContent(genericContentIds).subscribe((bulkGenericContent) => {
            this.genericContentItem = bulkGenericContent;
            for (const genericContent of bulkGenericContent) {
                switch (genericContent.id) {
                    case 'genericConvenienceFeeNote':
                        this.convenienceFeeNote = genericContent.content;
                        break;
                    default:
                        break;
                }
            }
        }, (error) => { });
    }
}
exports.CSEPHSBillingComponent = CSEPHSBillingComponent;
//# sourceMappingURL=billing.component.js.map